import { Suspense } from 'react';
import { Route, Routes, useMatch } from 'react-router-dom';
import { PATTERNS, ROUTES } from '@constants/routes';
import { useFormFeedback } from '@lib/hooks';
import { NotFound, RouteBoundary, SkeletonPage } from '@ui';
import { App } from './App';
import { AcceptInvitePage, HubFormPage, HubIntegrityTemplatePage, HubLandingPage, HubStatusPage, ShipmentVerifyPage } from './pages';

/**
 * Public pages answer without a session: no session check, no sign-in, no live stream (a printed note's QR is opened
 * by anyone, signed in or not; anyone may apply to run a Hub; a new Hub operator sets their password from an invitation). Everything else is the App.
 */
export function Root() {
  // every form, public or signed in: a refused submit shakes once and focuses the first invalid field
  useFormFeedback();
  const verify = useMatch(PATTERNS.shipmentVerify);
  const hub = useMatch(PATTERNS.hubRegistrationRoot);
  const invite = useMatch(PATTERNS.acceptInvite);
  if (hub) return <HubRegistrationRoutes />;
  if (invite)
    return (
      <RouteBoundary home={ROUTES.home}>
        <Suspense fallback={<SkeletonPage />}>
          <AcceptInvitePage />
        </Suspense>
      </RouteBoundary>
    );
  if (!verify) return <App />;
  return (
    <RouteBoundary home={ROUTES.home}>
      <Suspense fallback={null}>
        <Routes>
          <Route path={PATTERNS.shipmentVerify} element={<ShipmentVerifyPage />} />
        </Routes>
      </Suspense>
    </RouteBoundary>
  );
}

/** /hub-registration/*: the landing page, the form and the status check; an unknown page under it is the 404. */
function HubRegistrationRoutes() {
  const H = PATTERNS.hubRegistration;
  return (
    <RouteBoundary home={ROUTES.hubRegistration}>
      <Suspense fallback={<SkeletonPage />}>
        <Routes>
          <Route path={ROUTES.hubRegistration}>
            <Route index element={<HubLandingPage />} />
            <Route path={H.form} element={<HubFormPage />} />
            <Route path={H.status} element={<HubStatusPage />} />
            <Route path={H.integrity} element={<HubIntegrityTemplatePage />} />
            <Route path="*" element={<NotFound home={ROUTES.hubRegistration} />} />
          </Route>
        </Routes>
      </Suspense>
    </RouteBoundary>
  );
}
